<template>
  <div class="home-private-tab">
    <div class="home__top-banner" />
    <div class="home__header">
      <div v-if="hadLogin" class="home__header--login">
        <div class="home__header-left">
          <div class="home__header-welcome">欢迎</div>
          <div class="home__header-user">{{ mobile }}</div>
          <div class="home__header-btn-logout" @click="onPopupLogout">
            退出登录
          </div>
        </div>
      </div>
      <div v-else class="home__header--unlogin">
        <div class="home__header-welcome">欢迎</div>
        <div class="home__header-btn-login" @click="onPopupLogin">点击登录</div>
      </div>
    </div>
    <div class="home-points">
      <div class="home-points__title"></div>
      <div class="home-points__content">
        <div
          class="home-points__item"
          v-for="(link, index) in linksOfPoints"
          :key="index"
          @click="onRoute(hadLogin ? link.loginedUrl : link.unLoginedUrl)"
        >
          <img class="home-points__item-img" :src="link.image" />
        </div>
      </div>
    </div>
    <div class="home-rights">
      <div class="home-rights__title"></div>
      <div class="home-rights__content">
        <img
          class="home-rights__item"
          v-for="(link, index) in linksOfRights"
          :src="link.image"
          :key="index"
          @click="onRoute(hadLogin ? link.loginedUrl : link.unLoginedUrl)"
        />
      </div>
    </div>
    <div class="home-hot">
      <div class="home-hot__title"></div>
      <div class="home-hot__content">
        <div
          class="home-hot__item"
          v-for="(link, index) in linksOfHot"
          :key="index"
          @click="onRoute(hadLogin ? link.loginedUrl : link.unLoginedUrl)"
        >
          <img class="home-hot__item-img" :src="link.image" />
        </div>
      </div>
    </div>
    <van-dialog
      v-model:show="isLoginPopupVisble"
      show-cancel-button
      confirm-button-text="立即登录"
      :beforeClose="validateLogin"
      @confirm="onLogin"
    >
      <div class="login-form">
        <div class="login-title">登录</div>
        <div class="login-row">
          <div class="login-label">手机号后六位：</div>
          <input
            class="login-input"
            pattern="[0-9]*"
            type="tel"
            placeholder="请输入手机号后六位"
            v-model="mobile"
            @input="onMobileInput"
          />
        </div>
        <div class="login-row">
          <div class="login-label">身份证号后六位：</div>
          <input
            class="login-input"
            type="text"
            placeholder="请输入身份证号后六位"
            v-model="credentials"
            @input="onCredentialsInput"
          />
        </div>
        <div class="login-tip">*请输入华夏银行预留信息</div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import useLogin from '../hooks/useLogin'
import useHomeLogic from '../hooks/useHomeLogic'

export default {
  setup() {
    const {
      hadLogin,
      isLoginPopupVisble,
      mobile,
      credentials,
      validateLogin,
      onPopupLogin,
      onMobileInput,
      onCredentialsInput,
      onLogin,
      onPopupLogout
    } = useLogin()

    const { linksOfPoints, linksOfRights, linksOfHot, onRoute } = useHomeLogic()

    return {
      hadLogin,
      isLoginPopupVisble,
      mobile,
      credentials,
      linksOfPoints,
      linksOfRights,
      linksOfHot,
      validateLogin,
      onMobileInput,
      onPopupLogin,
      onCredentialsInput,
      onPopupLogout,
      onLogin,
      onRoute
    }
  }
}
</script>

<style lang="less" scoped>
.home-private-tab {
  background: #f8f8f8;
  min-height: 100vh;
  padding-bottom: 60px;
  .home__top-banner {
    width: 375px;
    height: 110px;
    background-image: url('../../../../assets/privite-top-banner.png');
    background-repeat: no-repeat;
    background-size: 100%;
  }
  .home__header {
    box-shadow: 1px 1px 3px 0px rgba(0, 0, 0, 0.1);
    .home__header--login {
      display: flex;
      height: 42px;
      justify-content: space-between;
      padding: 0 15px;
      margin-top: 0px;
      .home__header-left {
        display: flex;
        align-items: center;
        .home__header-welcome {
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #ff0000;
        }
        .home__header-user {
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #666666;
          margin-left: 8px;
        }
        .home__header-btn-logout {
          width: 82px;
          height: 28px;
          background: #ff2115;
          border-radius: 14px;
          margin-left: 15px;

          display: flex;
          align-items: center;
          justify-content: center;

          font-size: 15px;
          font-family: Source Han Sans CN;
          font-weight: bolder;
          color: #ffffff;
        }
        .home__header-btn-logout:active {
          opacity: 0.5;
        }
      }
      .home__header-right {
        width: 61px;
        height: 17px;
        background: #ffffff;
        border: 1px solid #ff2a1c;
        border-radius: 9px;

        font-size: 11px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #333333;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 4px;
      }
    }
    .home__header--unlogin {
      display: flex;
      align-items: center;
      height: 42px;
      padding: 0 15px;
      margin-top: 0px;
      .home__header-welcome {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #ff0000;
      }
      .home__header-btn-login {
        width: 82px;
        height: 28px;
        background: #ff2115;
        border-radius: 14px;
        margin-left: 15px;

        display: flex;
        align-items: center;
        justify-content: center;

        font-size: 15px;
        font-family: Source Han Sans CN;
        font-weight: bolder;
        color: #ffffff;
      }
      .home__header-btn-login:active {
        opacity: 0.5;
      }
    }
  }
  .home-points {
    width: 356px;
    height: 210px;
    margin-left: 10px;
    margin-top: 9px;
    background-image: url('../../../../assets/privite-points-bg.png');
    background-repeat: no-repeat;
    background-size: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    .home-points__title {
      width: 190px;
      height: 20px;
      margin-top: 14px;
      background-image: url('../../../../assets/privite-points-title.png');
      background-repeat: no-repeat;
      background-size: 100%;
    }
    .home-points__content {
      display: flex;
      justify-content: space-between;
      width: 338px;
      flex-wrap: wrap;
      margin-top: 12px;
      .home-points__item {
        .home-points__item-img {
          width: 165px;
          height: 70px;
        }
      }
      .home-points__item:active {
        opacity: 0.8;
      }
    }
  }
  .home-rights {
    width: 356px;
    height: 169px;
    margin-left: 10px;
    margin-top: 9px;
    background-image: url('../../../../assets/privite-rights-bg.png');
    background-repeat: no-repeat;
    background-size: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    .home-rights__title {
      width: 190px;
      height: 20px;
      margin-top: 14px;
      background-image: url('../../../../assets/privite-rights-title.png');
      background-repeat: no-repeat;
      background-size: 100%;
    }
    .home-rights__content {
      width: 323px;
      margin-top: 14px;
      display: flex;
      justify-content: space-between;
      .home-rights__item {
        width: 95px;
        height: 110px;
      }
      .home-rights__item:active {
        opacity: 0.8;
      }
    }
  }
  .home-hot {
    width: 356px;
    height: 136px;
    margin-left: 10px;
    margin-top: 9px;
    background-image: url('../../../../assets/privite-hot-bg.png');
    background-repeat: no-repeat;
    background-size: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    .home-hot__title {
      width: 190px;
      height: 20px;
      margin-top: 14px;
      background-image: url('../../../../assets/privite-hot-title.png');
      background-repeat: no-repeat;
      background-size: 100%;
    }
    .home-hot__content {
      display: flex;
      justify-content: space-between;
      width: 323px;
      margin-top: 13px;
      .home-hot__item {
        .home-hot__item-img {
          width: 155px;
          height: 77px;
          background-image: url('../../../../assets/privite-hot-item.png');
          background-repeat: no-repeat;
          background-size: 100%;
        }
      }
      .home-hot__item:active {
        opacity: 0.8;
      }
    }
  }
  .login-form {
    .login-title {
      font-size: 15px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #333333;
      text-align: center;
      margin-top: 26px;
    }
    .login-row {
      display: flex;
      align-items: center;
      margin-top: 17px;
      .login-label {
        min-width: 120px;
        font-size: 13px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #121212;
        text-align: right;
      }
      .login-input {
        width: 160px;
        height: 30px;
        background: #f2f2f2;
        border: 1px solid #cccccc;
        border-radius: 5px;
        padding: 0;
        padding-left: 3px;
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        -webkit-appearance: none;
      }
    }
    .login-tip {
      font-size: 13px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ff2115;
      text-align: center;
      margin: 17px 0;
    }
  }
}
</style>
